import styled, { css } from 'styled-components';
import { GlobalModal, showGlobalModal } from '../../services/modal';
import { doneTask, TaskOrientation, TaskProps } from '../../services/task';
import { colorBlend } from '../../utils/style';
import TaskAttributes from './TaskAttributes';
import TaskDescription from './TaskDescription';
import TaskExperience from './TaskExperience';
import TaskStatus from './TaskStatus';
import TaskType from './TaskType';

interface Props {
    orientation: TaskOrientation,
    task: TaskProps,
}

export default function Task({ orientation, task }: Props) {

    return (
        <Wrapper onClick={() => showGlobalModal(GlobalModal.EDIT_TASK, task)} orientation={orientation} className={`${task.done && 'done'}`}>
            <TaskExperience rewards={task.rewards} />
            <TaskType parent={task.parent} type={task.type} />
            <TaskDescription name={task.name} description={task.description} />
            <TaskAttributes duration={task.duration} difficulty={task.difficulty} />

            <TaskStatus orientation={orientation} done={task.done} onClick={() => { doneTask(task.id) }} />
        </Wrapper >
    )
}

const Wrapper = styled.div<{ orientation: TaskOrientation }>`
    padding: 10px;
    background-color: ${props => props.theme.foregroundColor};
    border-radius: ${props => props.theme.borderRadius};
    text-align: center;
    transition: transform var(--ui-animation-duration), opacity var(--ui-animation-duration);
    display: grid;

    &.done {
        /* background-color: #00796b; */
        background-color: ${props => colorBlend(props.theme.foregroundColor, '#11796b', 0.5)};
        opacity: 0.4;

        .task-xp {
            background-color: #00796b;
        }
    }

    &:hover {
        /* transform: translateX(4px); */
        opacity: 1;
        .task-status {
            transform: scale(1.2)
        }
    }

    ${({ orientation }) => orientations[orientation]}
`

const orientations = {
    [TaskOrientation.HORIZONTAL]: css`
        grid-template-rows: 60px 30px 120px 50px 10px;
        grid-template-columns: 100%;

        grid-template-areas: 
            "experience"
            "type"
            "description"
            "attributes"
            "status"
        ;

        width: 200px;
        min-width: 200px;
        min-height: 250px;
    `,
    [TaskOrientation.VERTICAL]: css`
        grid-template-rows: 60px 30px 30px;

        /* grid-template-columns: 30px 200px 10px minmax(300px, auto);
        grid-template-areas: 
            "status experience . description"
            "status type       . description"
            "status attributes . description"
        ; */

        grid-template-columns: 16px minmax(160px, 400px) 10px minmax(120px, 180px);
        grid-template-areas: 
            "status description . experience"
            "status description       . type"
            "status description . attributes"
        ;
    `,
}